<div class="container">
    <div #canvas class="diagram-container" id="canvas">
        <mat-button-toggle-group
            class="modelEditorToggleButtons"
            value="myProducts"
            (change)="toggleButtonChange($event)"
        >
            <mat-button-toggle value="myProducts"
                >Meine Produkte</mat-button-toggle
            >
            <mat-button-toggle value="organisations"
                >Organisationen</mat-button-toggle
            >
        </mat-button-toggle-group>
        <mat-form-field
            *ngIf="!showMyProducts"
            appearance="fill"
            class="organisationSelect"
        >
            <mat-label>Organisation</mat-label>
            <mat-select
                [value]="selectedOrganisation"
                (selectionChange)="changedSelectedOrganisation($event)"
            >
                <mat-option
                    *ngFor="let membership of availableProductOrganisations"
                    [value]="membership"
                    >{{ membership.organisationName }}</mat-option
                >
            </mat-select>
        </mat-form-field>
    </div>
    <div class="diagram-properties-panel" id="propertiesPanel"></div>
</div>
